import axios from "axios";

export default axios.create({
  baseURL: "https://api.zpcosmeticos.com.br",
});
